import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';

@Pipe({
  name: 'markdown',
  standalone: true
})
export class MarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null): SafeHtml {
    if (!value) {
      return '';
    }

    try {
      // Настройка marked для поддержки таблиц и других элементов
      marked.setOptions({
        breaks: true,
        gfm: true // GitHub Flavored Markdown
      });

      let html = marked.parse(value) as string;
      
      // Обрабатываем отдельные <code> блоки, которые содержат переносы строк
      // Если <code> содержит <br> или несколько строк, делаем его блочным
      html = html.replace(
        /<code(?![^>]*class=)([^>]*)>([\s\S]*?)<\/code>/g,
        (match, attributes, content) => {
          // Проверяем, содержит ли код переносы строк или это многострочный блок
          const hasNewlines = content.includes('\n') || content.includes('<br') || content.trim().split(/\s+/).length > 10;
          const isStandalone = !match.includes('pre');
          
          if (hasNewlines && isStandalone) {
            // Добавляем класс для идентификации блочного кода
            return `<code${attributes} class="code-block" style="display: block;">${content}</code>`;
          }
          
          return match;
        }
      );
      
      // Обрабатываем якорные ссылки (href="#...") - добавляем класс для идентификации
      html = html.replace(
        /<a\s+([^>]*href=["']#([^"']+)["'][^>]*)>/gi,
        (match, attributes, anchorId) => {
          // Добавляем класс для якорных ссылок
          const className = 'anchor-link';
          if (attributes.includes('class=')) {
            return match.replace(/class=["']([^"']+)["']/, `class="$1 ${className}"`);
          } else {
            return `<a ${attributes} class="${className}">`;
          }
        }
      );
      
      // Генерируем ID для заголовков, чтобы якорные ссылки могли их найти
      // Сначала обрабатываем заголовки с атрибутами (если они уже есть)
      html = html.replace(
        /<h([1-6])([^>]*)>([^<]+)<\/h[1-6]>/gi,
        (match, level, attributes, text) => {
          // Если уже есть id, не добавляем новый
          if (attributes.includes('id=')) {
            return match;
          }
          
          // Создаем ID из текста
          const id = text
            .toLowerCase()
            .replace(/[^\w\s-]/g, '') // Убираем спецсимволы
            .replace(/\s+/g, '-') // Заменяем пробелы на дефисы
            .replace(/-+/g, '-') // Убираем множественные дефисы
            .trim();
          
          return `<h${level}${attributes} id="${id}">${text}</h${level}>`;
        }
      );
      
      // Используем bypassSecurityTrustHtml для безопасного рендеринга HTML
      return this.sanitizer.bypassSecurityTrustHtml(html);
    } catch (error) {
      console.error('Error parsing markdown:', error);
      return value;
    }
  }
}

